import {Component, OnDestroy, OnInit} from '@angular/core';
import {PaymentService} from '../../../../core/services/impl/payment.service';
import {InternalConfigService} from '../../../services/internal-config.service';
import {NextSuccessNotificationContext, NotificationState} from '../../../models/notification-state';
import {ApplicationContextService} from '../../../../core/services/impl/configuration/application-context.service';
import {NotificationMode, NotificationStateService} from '../../../services/notification-state.service';
import {NotificationComponentKey} from '../../../../core/enums/components-keys';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

  NotificationComponentKey = NotificationComponentKey;

  otherProductsVisibleNotifications: NotificationComponentKey[] = [
      NotificationComponentKey.PAYMENT_SUCCESS,
  ];

  constructor(private notificationStateService: NotificationStateService,
              private paymentService: PaymentService,
              private contextService: ApplicationContextService,
              public internalConfigService: InternalConfigService) {
  }

  get notificationState(): NotificationState {
    return this.notificationStateService.notificationState;
  }

  get mode(): NotificationMode {
    return this.notificationStateService.notificationMode;
  }

  get awaiting(): boolean {
    return this.notificationStateService.awaiting;
  }

  get isMessageTranslated(): boolean {
    return this.notificationStateService.isMessageTranslated;
  }

  get loaderVisible(): boolean {
    return this.notificationStateService.loaderVisible;
  }

  get activeNotification(): NotificationComponentKey | null {
    return this.notificationState ? this.notificationState.activeNotification : null;
  }

  get otherProductsVisible(): boolean {
    return this.internalConfigService.otherProductsVisible && this.otherProductsVisibleNotifications.includes(this.activeNotification);
  }

  ngOnInit() {
    this.initNotification();
    this.sendMetric();
  }

  ngOnDestroy() {
    this.notificationStateService.destroyed = true;
  }

  private initNotification(): void {
    switch (this.mode) {
      case NotificationMode.PAYMENT_STATUS:
        this.initNotificationForPaymentStatus();
        break;
    }

    if (this.contextService.isDiagnosticStationContext) {
      this.notificationStateService.setNextSuccessNotification(NextSuccessNotificationContext.DIAGNOSTIC_STATION);
    }
  }

  private initNotificationForPaymentStatus(): void {
    this.paymentService.initPaymentStatus();
  }

  private sendMetric(): void {
    if (this.notificationState && !!this.notificationState.message) {
      this.notificationStateService.sendNotificationComponentMetric('NotificationComponent', { message: this.notificationState.message });
    }
  }
}

export interface PaymentStatus {
  code: number;
  statusCode: string;
  message: string;
}
